import Vue from 'vue';
import { mapGetters } from 'vuex';

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import reportConclusions from '@/components/reports/reportConclusions/index.vue';
import reportStatistics from '@/components/reports/reportStatistics/index.vue';
import errorConclusions from '@/components/reports/errorConclusions/index.vue';
import reportComments from '@/components/reports/reportComments/index.vue';
import reportHistory from '@/components/reports/reportHistory/index.vue';
import reportInconsistencies from '@/components/reports/reportInconsistencies/index.vue';
import reportErrors from '@/components/reports/detail/reportErrors/index.vue';

import reportInfo from '@/components/reports/detail/reportInfo/index.vue';
import reportTabs from '@/components/reports/detail/reportTabs/index.vue';

import buttonLoader from '@/components/button';
import rating from '@/components/rating/index.vue';

import Api from '@/utils/api';

import helpers from '@/mixins/helpers';

export default Vue.extend({
  components: {
    Multiselect,
    reportConclusions,
    reportStatistics,
    errorConclusions,
    reportComments,
    reportHistory,
    reportInconsistencies,
    reportInfo,
    reportTabs,
    reportErrors,
    buttonLoader,
    rating,
  },
  mixins: [
    helpers.general,
  ],
  data () {
    return {
      reportData: {},
      activeTab: 0,
    };
  },
  computed: {
    reportComment () {
      return true;
      // return this.checkPermissions('report', 'report-comment-add-report');
    },
    ...mapGetters({
      user: 'user',
    }),
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', true);
    this.getReport().finally(() => {
      this.$store.dispatch('SHOW_PRELOADER', false);
    });
  },
  methods: {
    /**
         * Method for getting data
         */
    getReport () {
      return Api.reports
        .get(this.$route.params.id)
        .then((response) => {
          if (response.data.Status) {
            this.reportData = response.data.Data;
            this.transformResponse();
            this.refreshReportStore();
          }
        });
    },

    /**
         * Method for transform response data
         */
    transformResponse () {
      if (this.reportData.IndustryFieldName.length > 0) {
        this.reportData.IndustryFieldName.forEach((item, key) => {
          this.reportData.IndustryFieldName[key] = item.split(',');
        });
      }
    },

    /**
         * Send information from report conclusion and error conclusion
         */
    refreshReportStore () {
      const data = {
        ReportId: this.reportData.ReportID,
        ReportType: this.reportData.ReportType,
        ErrorConclusionList: [],
      };

      this.$store.dispatch('REPORTS_DATA_CUSTOMER_UPDATE', data);
    },

    /**
         * Method for update data
         */
    updateReportHolder (data) {
      this.reportData.Rating = data.rating;
      this.reportData.KOStatus = data.ko;
      this.reportData.ReportType = data.type;
      this.reportData.UsedMetarules = data.metarules;
    },
  },
});
